const DEFAULT_ID_SCOPE = 'id__';

const ID_MAP: Record<string, number> = {};

/**
 * Generate a unique id in specified scope.
 * The id text uses the `scope` as prefix.
 *
 * @param scope Optional scope for the counter. Default is `id__`
 * @returns The id text with `scope` as prefix.
 */
export function generateId(scope: string = DEFAULT_ID_SCOPE): string {
  if (ID_MAP[scope] === undefined) {
    ID_MAP[scope] = 0;
  }
  const id = ID_MAP[scope]++;
  return `${scope}${id}`;
}

/**
 * Reset id counter to an (optional) number.
 *
 * @param scope The scope for the counter.
 * @param value the optional number value. Default is `0`.
 */
export function resetId(
  scope: string = DEFAULT_ID_SCOPE,
  value: number = 0,
): void {
  ID_MAP[scope] = value;
}
